var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.36328C0.447715 6.36328 0 6.811 0 7.36328C0 7.91557 0.447715 8.36328 1 8.36328V7.36328V6.36328ZM17.7071 8.07039C18.0976 7.67986 18.0976 7.0467 17.7071 6.65617L11.3431 0.292213C10.9526 -0.0983109 10.3195 -0.0983109 9.92893 0.292213C9.53841 0.682738 9.53841 1.3159 9.92893 1.70643L15.5858 7.36328L9.92893 13.0201C9.53841 13.4107 9.53841 14.0438 9.92893 14.4343C10.3195 14.8249 10.9526 14.8249 11.3431 14.4343L17.7071 8.07039ZM1 7.36328V8.36328H17V7.36328V6.36328H1V7.36328Z",
    fill: "url(#paint0_linear_5099_12889)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5099_12889",
    x1: 9,
    y1: 7.36328,
    x2: 9,
    y2: 8.48828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#058282"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.c021b8308f840e5fce3390906dc5bb96.svg";
export { ForwardRef as ReactComponent };